define(function (require) {
    "use strict";

    var LE = require("app");
    var ContentSystemModel = require("content-models/system/ContentSystemModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentSystemUtilities = require("content-utils/ContentSystemUtilities");

    var SystemCollection = {};
    var NAME = "SystemCollection";

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        SystemCollection = RevisionedCollection.extend({
            name: NAME,
            model : ContentSystemModel,
            resource: ApiResources.AccountConfig.SystemMessages,

            url: function(){
                var url = RevisionedCollection.prototype.url.call(this);
                url+= "&lang="+ LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",");
                return url += "&view=FILTER_PER_SKILL";
            },

            comparator: function(model) {
                return model.get("messageEventId");
            },

            parse: function(resp, options) {
                var parsedResp = [];
                _.each(resp, function (message) {
                    if(!ContentSystemUtilities.isMessageDiscontinued(message.messageEventId)){
                        parsedResp.push(message);
                    }
                }, this);
                return RevisionedCollection.prototype.parse.call(this, parsedResp, options);
            }
        });
    });

    SystemCollection.NAME = NAME;

    return SystemCollection;
});
